"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPartyPlayer = void 0;
var vue_1 = require("vue");
var Button_1 = require("../components/common/Button");
var SelectPlayerRow_1 = require("./SelectPlayerRow");
var TranslateMixin_1 = require("./TranslateMixin");
exports.SelectPartyPlayer = vue_1.default.component('select-party-player', {
    props: {
        players: {
            type: Array,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            selectedPlayer: undefined,
        };
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    components: {
        'Button': Button_1.Button,
        'select-player-row': SelectPlayerRow_1.SelectPlayerRow,
    },
    methods: {
        saveData: function () {
            var result = [];
            result.push([]);
            if (this.selectedPlayer !== undefined) {
                result[0].push(this.selectedPlayer);
            }
            this.onsave(result);
        },
    },
    template: "<div>\n  <div v-if=\"showtitle === true\">{{ $t(playerinput.title) }}</div>\n  <label v-for=\"player in (playerinput.players || [])\" :key=\"player\" class=\"form-radio form-inline\">\n    <input type=\"radio\" v-model=\"selectedPlayer\" :value=\"player\" />\n    <i class=\"form-icon\"></i>\n    <span v-if=\"player === 'NEUTRAL'\" >Neutral</span>\n    <select-player-row v-else :player=\"players.find((otherPlayer) => otherPlayer.color === player)\"></select-player-row>\n  </label>\n  <Button v-if=\"showsave === true\" size=\"big\" :onClick=\"saveData\" :title=\"$t(playerinput.buttonLabel)\" />\n</div>",
});
//# sourceMappingURL=SelectPartyPlayer.js.map